<template>
  <div class="message-div">
    <Appbar title="站内信">
    </Appbar>

    <v-list-item style="flex: none;">
      <v-list-item-avatar>
        <v-img src="@/static/pages/message/notice.png"></v-img>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>{{mail.messageTitle}}</v-list-item-title>
        <v-list-item-subtitle>{{mail.creationTime}}</v-list-item-subtitle>
      </v-list-item-content>

    </v-list-item>

    <v-divider></v-divider>

    <div class="message-content" id="mail-editor-html" v-html="mail.content"></div>

  </div>
</template>

<script>
import Appbar from "@c/layout/Appbar";
import { ApiMessageReadById } from "@/api/service.js";
export default {
  components: {
    Appbar,
  },
  data() {
    return {
      mail: {},
    };
  },
  methods: {
    getDetail() {
      let query = this.$route.query;

      // if(this.mailList&&this.mailList.length){
      //     this.mail=this.mailList.find(item=>item.messageId==query.msgId)
      // }else{
      this.$store
        .dispatch("message/getMailByPage", {
          page: 1,
          limit: query.index * 1 + 1,
        })
        .then((res) => {
          this.mail = res.data.list.find(
            (item) => item.messageId == query.msgId
          );
          this.$nextTick(() => {
            window.uParse('#mail-editor-html', {
                rootPath: this._cdn + '/pc/common/Ueditor/third-party'
            })
            })
        });
      // }

      // if(this.mail.isRead===1) return
      // ApiMessageReadById({messageId});//根据id设为已读
      // this.$store.dispatch("message/getMailByPage",{page:1,limit:20})
    },
  },
  created() {
    this.getDetail();
  },
};
</script>

<style lang="scss">
.message-div {
  background-color: #fff;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  .message-content {
    padding: 20px 10px;
    overflow: auto;
    word-break: break-all;
  }
  .v-divider {
    width: 100%;
  }
  .v-list-item__subtitle,
  .v-list-item__title {
    word-break: break-all;
    white-space: initial;
  }
}
</style>
